import { useContext } from 'react';
import { UserLockerContext } from '../../contexts/UserLockerContext';

const useUserLocker = () => useContext(UserLockerContext);

export default useUserLocker;
